import clsx from 'clsx';

import type { HTMLAttributes, KeyboardEvent, MouseEvent, TouchEvent } from 'react';

import s from './Overlay.module.css';

type OverlayProps = HTMLAttributes<HTMLDivElement>;

export const Overlay = ({ className, onClick, onKeyDown, onTouchEnd, onTouchStart, ...props }: OverlayProps) => {
  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    onClick?.(e);
  };

  const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    e.stopPropagation();

    onTouchStart?.(e);
  };

  const handleTouchEnd = (e: TouchEvent<HTMLDivElement>) => {
    e.stopPropagation();

    onTouchEnd?.(e);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation();
    }

    onKeyDown?.(e);
  };

  return (
    <div
      className={clsx(s.overlay, className)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onTouchEnd={handleTouchEnd}
      onTouchStart={handleTouchStart}
      role="button"
      tabIndex={0}
      {...props}
    />
  );
};
